module.exports = __webpack_public_path__ + "img/loveLogo.2a166b27.svg";